import { openDB, type DBSchema, type IDBPDatabase } from "idb";

interface BlobDB extends DBSchema {
  blobs: { key: string; value: Blob };
}

let dbPromise: Promise<IDBPDatabase<BlobDB>> | null = null;

function getDb(): Promise<IDBPDatabase<BlobDB>> {
  if (!dbPromise) {
    dbPromise = openDB<BlobDB>("camera-scanner", 2, {
      upgrade(db, oldVersion) {
        if (oldVersion < 1) {
          db.createObjectStore("blobs");
        }
        // v2: scripts/pages metadata moved to TanStack DB local collections
        // (localStorage) — drop the now-unused idb stores, keep blobs as-is.
        if (oldVersion < 2) {
          const names = db.objectStoreNames as unknown as DOMStringList;
          if (names.contains("scripts")) db.deleteObjectStore("scripts" as never);
          if (names.contains("pages")) db.deleteObjectStore("pages" as never);
        }
      },
    });
  }
  return dbPromise;
}

export const blobStore = {
  async get(key: string): Promise<Blob | undefined> {
    const db = await getDb();
    return db.get("blobs", key);
  },

  async set(key: string, blob: Blob): Promise<void> {
    const db = await getDb();
    await db.put("blobs", blob, key);
  },

  async delete(key: string): Promise<void> {
    const db = await getDb();
    await db.delete("blobs", key);
  },
};
